export enum ConfigType {
  ConfigId = "configId",
  NetworkId = "networkId",
  AdId = "adId",
  PubId = "pubId",
  CampaignId = "campaignId"
}
